import { baseWorkflowsUrl } from 'automation-ui-routing/workflowsUrls';
export const redirectToOtherWorkflowsApp = ({
  location: {
    pathname,
    search,
    hash
  }
}) => {
  window.location.href = window.location.origin + baseWorkflowsUrl() + pathname + search + hash;
};